import React from 'react';
import {Apps as AppsIcon} from '@mui/icons-material';
import {ListItemButton, ListItemIcon, ListItemText} from '@mui/material';
import {bool, oneOf} from 'prop-types';

import NavMenuButton from './NavMenuButton.jsx';
import {APPS, ENVIRONMENTS, LEGACY_SH_APPS} from '../apps.jsx';

const APP_KEYS = [
  'explorer',
  'featuresManager',
  'tasking',
  'stories',
  'basemapsViewer',
  'feedsViewer',
];

/**
 * Menu with links to Planet web applications. Used in `NavBar` component, but can be imported as a standalone component as well.
 */
const AppsMenu = ({
  environment = ENVIRONMENTS.production,
  includeLegacySentinelHubApps,
}) => {
  return (
    <NavMenuButton
      title="Applications Menu"
      label={<AppsIcon fontSize="small" />}
      aria-label="Planet Applications"
    >
      {APP_KEYS.filter(id => APPS[id].href[environment]).map(key => {
        const app = APPS[key];
        return (
          <ListItemButton
            key={key}
            rel="noreferrer noopener"
            href={app.href[environment]}
            target="_blank"
          >
            <ListItemIcon
              sx={{
                color: 'inherit',
                minWidth: theme => theme.spacing(5),
              }}
            >
              <app.icon />
            </ListItemIcon>
            <ListItemText>{app.title}</ListItemText>
          </ListItemButton>
        );
      })}
      {includeLegacySentinelHubApps &&
        LEGACY_SH_APPS.map(shApp => (
          <ListItemButton
            key={shApp.id}
            rel="noreferrer noopener"
            href={shApp.href[environment]}
            target="_blank"
          >
            <ListItemIcon
              sx={{
                color: 'inherit',
                minWidth: theme => theme.spacing(5),
              }}
            >
              <shApp.icon />
            </ListItemIcon>
            <ListItemText>{shApp.title}</ListItemText>
          </ListItemButton>
        ))}
    </NavMenuButton>
  );
};

AppsMenu.propTypes = {
  /**
   * Environment to use for links
   */
  environment: oneOf(Object.values(ENVIRONMENTS)),

  includeLegacySentinelHubApps: bool,
};

export default AppsMenu;
